import { render, staticRenderFns } from "./newPurchaseOrder.vue?vue&type=template&id=5fcab3d4&"
import script from "./newPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./newPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports